import React, { lazy, Suspense, useState, useEffect, useContext } from 'react';
import styled from 'styled-components';
import EnhancedThemeProvider from 'components/EnhancedThemeProvider';
import Loading from 'components/Loading';
import { AppContext } from 'shared/AppContext';
import { ScannerSelectModal } from './components/ScannerSelectModal';

const ScanPage = lazy(() => import('./ScanPage'));

const ScanContainer = styled.div`
  top: 0;
  left: 0;
  height: 100vh;
  width: 100%;
  overflow: hidden;
  position: relative;

  @media (min-width: 768px) {
    height: 100vh;
    width: 80%;
    margin: 0 auto;
  }
`;

const Scan = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);

  const {
    state: { janamScanners },
  } = useContext(AppContext);

  useEffect(() => {
    if (janamScanners) {
      setIsModalVisible(true);
    } else {
      // No Janam scanners — default to phone camera
      setSelectedOption('phone');
    }

    return () => {
      setSelectedOption(null);
    };
  }, [janamScanners]);

  return (
    <EnhancedThemeProvider className="">
      {!selectedOption && janamScanners ? (
        <Loading />
      ) : (
        <Suspense fallback={<Loading />}>
          <ScanContainer>
            <ScanPage useJanamScanner={selectedOption === 'janam'} />
          </ScanContainer>
        </Suspense>
      )}
      <ScannerSelectModal
        isVisible={isModalVisible}
        setIsVisible={setIsModalVisible}
        setSelectedOption={setSelectedOption}
      />
    </EnhancedThemeProvider>
  );
};

export default Scan;
